import {FormControlLabel, Switch} from '@mui/material';
import React from 'react';

interface Props {
  isMobileMode: boolean;
  setIsMobileMode: Function;
}

export default function Switcher(props: Props) {
  const {isMobileMode, setIsMobileMode} = props;
  return (
    <FormControlLabel
      value="start"
      labelPlacement="start"
      control={
        <FormControlLabel
          style={{padding: 10}}
          control={
            <Switch
              checked={isMobileMode}
              onChange={e => setIsMobileMode(e.target.checked)}
            />
          }
          label="Mobile View"
        />
      }
      label="Web View"
    />
  );
}
